import { render, staticRenderFns } from "./Peligro.vue?vue&type=template&id=e3c33198&scoped=true"
import script from "./Peligro.vue?vue&type=script&lang=ts"
export * from "./Peligro.vue?vue&type=script&lang=ts"
import style0 from "./Peligro.vue?vue&type=style&index=0&id=e3c33198&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3c33198",
  null
  
)

export default component.exports